<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'home' })"
          v-tooltip="$t('back')"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ $t('homePage.myRequest') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('homePage.myRequest'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.request_id }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.request_date }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.requester }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              <span
                class="badge badge-info"
                v-if="record.request_status == 'Pending'"
                >{{ $t('home.pending') }}</span
              >
              <span
                class="badge badge-primary"
                v-if="record.request_status == 'Partialy Approved'"
                >{{ $t('home.partiallyApproved') }}</span
              >
              <span
                class="badge badge-success"
                v-if="record.request_status == 'Approved'"
                >{{ $t('home.approved') }}</span
              >
              <span
                class="badge badge-danger"
                v-if="record.request_status == 'Rejected'"
                >{{ $t('home.rejected') }}</span
              >
            </td>
          </template>
        </ts-table>
      </div>
      <ts-card-wrapper class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'myRequest',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('home/studentRequestLinkFromHome', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.home.studentRequestLinkFromHome.search
      },
      set(newVal) {
        this.$store.commit('home/studentRequestLinkFromHome/SET_SEARCH', newVal)
        this.$store.commit('home/studentRequestLinkFromHome/RESET_CURRENT_PAGE')
      }
    },
    approve_status: {
      get() {
        return this.$store.state.home.studentRequestLinkFromHome.approve_status
      },
      set(newValue) {
        this.$store.commit(
          'home/studentRequestLinkFromHome/SET_APPROVE_STATUS',
          newValue
        )
      }
    },
    columns() {
      return [
        { name: this.$t('homePage.requestId') },
        { name: this.$t('homePage.requestDate'), style: 'text-align: center' },
        { name: this.$t('homePage.requester') },
        { name: this.$t('homePage.status'), style: 'text-align: center' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('home/studentRequestLinkFromHome/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    approve_status: debounce(function(approve_status) {
      this.fetchData({ approve_status })
    }, 500)
  }
}
</script>
